import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  rspvFormApi,
  rspvPostFormApi,
  rspvPostNameMatch,
  rspvAdditionalGuestApi,
  getDynamicRsvpQuestions,
  postQuestionSelection,
  getCeremoniesForRsvp,
  getRSVPDynamicQuestions,
  getRSVPResponsess,
  getWeddingWebsite,
  getRsvpContactDetails,
  postRsvpContactDetails,
  getRsvpDateContactDetails,
  postRsvpDateContactDetails,
  postWeddingWebsiteImage,
  postWeddingWebsiteText,
  postWeddingContact,
  postDeleteWeddingWebsiteImage,
} from "./Api";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
const initialState = {
  question_id: [],
  response: [],
  successMessage: "",
  userQuestions: [],
  selectedCeremoniesForRsvp: [],
  loading: false,
  error: null,
};

export const getRsvpContact = createAsyncThunk(
  "rspv/getRsvpContact",
  async (rsvpCode) => {
    try {
      const response = await getRsvpContactDetails(rsvpCode);
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  }
);

export const postRsvpContact = createAsyncThunk(
  "rspv/postRsvpContact",
  async (data) => {
    try {
      const response = await postRsvpContactDetails(data.rsvpCode, data);
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  }
);

export const getRsvpDateContact = createAsyncThunk(
  "rspv/getRsvpContact",
  async (rsvpCode) => {
    try {
      const response = await getRsvpDateContactDetails(rsvpCode);
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  }
);

export const postRsvpDateContact = createAsyncThunk(
  "rspv/postRsvpContact",
  async (data) => {
    try {
      const response = await postRsvpDateContactDetails(data.rsvpCode, data);
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  }
);


export const getWeddingWebsiteData = createAsyncThunk(
  "rspv/getWeddingWebsiteData",
  async (rsvpCode) => {
    try {
      const response = await getWeddingWebsite(rsvpCode);
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  }
);
export const saveWeddingWebsiteImage = createAsyncThunk(
  "rspv/saveWeddingWebsiteImage",
  async (data) => {
    try {
      const response = await postWeddingWebsiteImage(data);
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  }
);
export const deleteWeddingWebsiteImage = createAsyncThunk(
  "rspv/deleteWeddingWebsiteImage",
  async (data) => {
    try {
      const response = await postDeleteWeddingWebsiteImage(data);
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  }
);

export const saveWeddingWebsiteText = createAsyncThunk(
  "rspv/saveWeddingWebsiteText",
  async (data) => {
    try {
      const response = await postWeddingWebsiteText(data);
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  }
);
export const sendWeddingContact = createAsyncThunk(
  "rspv/sendWeddingContact",
  async (data) => {
    try {
      const response = await postWeddingContact(data);
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  }
);


export const getUserRspvForm = createAsyncThunk(
  "rspv/getUserRspvForm",
  async () => {
    try {
      const response = await rspvFormApi();
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  }
);


export const postUserRspvForm = createAsyncThunk(
  "rspv/postUserRspvForm",
  async (data) => {
    try {
      const response = await rspvPostFormApi(data);
      return response.data;
    } catch (error) {
      const errorMessage = error?.response?.data?.error;
      toast.error(errorMessage, {
        position: "top-right",
        autoClose: 6000,
      });
      throw new Error(error.response.data.message);
    }
  }
);

export const postRSVPNameMatch = createAsyncThunk(
  "rspv/postRSVPNameMatch",
  async (data) => {
    try {
      const response = await rspvPostNameMatch(data);
      return response.data;
    } catch (error) {
      const errorMessage = error?.response?.data?.error;
      if (errorMessage) toast.error(errorMessage, {
        position: "top-right",
        autoClose: 6000,
      });
      console.log(errorMessage);
    }
  }
);

export const postAdditionalGuestRspvForm = createAsyncThunk(
  "rspv/postAdditionalGuestRspvForm",
  async (data) => {
    try {
      const response = await rspvAdditionalGuestApi(data);
      return response.data;
    } catch (error) {
      const errorMessage = error?.response?.data?.error;
      toast.error(errorMessage, {
        position: "top-right",
        autoClose: 6000,
      });
      throw new Error(error.response.data.message);
    }
  }
);
export const getUserDynamicRsvpQuestions = createAsyncThunk(
  "rspv/getDynamicRsvpQuestions",
  async () => {
    try {
      const response = await getDynamicRsvpQuestions();
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  }
);

export const getRsvpDynamicRsvpQuestions = createAsyncThunk(
  "rspv/getRsvpDynamicRsvpQuestions",
  async (data) => {
    try {
      const response = await getRSVPDynamicQuestions(data);
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  }
);

export const getRSVPResponses = createAsyncThunk(
  "rsvp/getRSVPResponses",
  async (data) => {
    const response = await getRSVPResponsess(data);
    return response.data;
  }
);

export const saveQuestionSelection = createAsyncThunk(
  "rspv/saveQuestionSelection",
  async (data) => {
    try {
      const response = await postQuestionSelection(data);
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  }
);
export const getAllSelectedCeremoneisForRsvp = createAsyncThunk(
  "rspv/getAllSelectedCeremoneisForRsvp",
  async (id) => {
    try {
      const response = await getCeremoniesForRsvp(id);
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  }
);

const rsvpSlice = createSlice({
  name: "rspv",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getUserRspvForm.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getUserRspvForm.fulfilled, (state, action) => {
        state.loading = false;
        state.questions = action.payload;
        state.error = null;
      })
      .addCase(getUserRspvForm.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(postUserRspvForm.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(postUserRspvForm.fulfilled, (state, action) => {
        const { question_id, response } = action.payload;
        state.loading = false;
        state.question_id = question_id;
        state.response = response;
        state.error = null;
        state.successMessage = "form submitted successfully";
      })
      .addCase(postUserRspvForm.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(postAdditionalGuestRspvForm.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(postAdditionalGuestRspvForm.fulfilled, (state, action) => {
        const { question_id, response } = action.meta.arg;

        state.loading = false;
        state.question_id = question_id;
        state.response = response;
        state.error = null;
        toast.success("Additional Guest Add successfully", {
          position: "top-right",
          autoClose: 6000,
        });
      })
      .addCase(getUserDynamicRsvpQuestions.fulfilled, (state, action) => {
        state.loading = false;
        state.userQuestions = action.payload;
        state.error = null;
      })

      .addCase(getAllSelectedCeremoneisForRsvp.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedCeremoniesForRsvp = action.payload;
        state.error = null;
      })

      .addCase(postAdditionalGuestRspvForm.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default rsvpSlice.reducer;
